import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { skokieConfig } from "./data";

export default function SkokiePage() {
  return <CityPageTemplate config={skokieConfig} />;
}